import React from 'react';
import '../../../styles/modes/autoMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Auto Find Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Automatically solve Traveling Salesman Problems (TSP) using optimization algorithms to find the shortest tour that visits all points exactly once and returns to the start.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least 3 location points set up in Setup Mode</li>
            <li>Start point designated (required)</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Review Configuration:</strong>
              <ul>
                <li>Verify all location points are displayed</li>
                <li>Confirm start point is set (marked with S)</li>
              </ul>
            </li>
            <li><strong>Select Algorithm:</strong>
              <ul>
                <li>Choose from dropdown menu</li>
                <li>Options include Nearest Neighbor, 2-Opt, and combined methods</li>
                <li>Different algorithms balance speed vs solution quality</li>
              </ul>
            </li>
            <li><strong>Click "Auto Solve":</strong>
              <ul>
                <li>System calculates optimal tour</li>
                <li>Results display automatically</li>
                <li>Path shown on map with connections</li>
              </ul>
            </li>
            <li><strong>Review Results:</strong>
              <ul>
                <li>Total distance in kilometers</li>
                <li>Tour sequence (order of points visited)</li>
                <li>Visual route on map</li>
                <li>Solution steps (for educational purposes)</li>
              </ul>
            </li>
            <li><strong>View Step-by-Step Process (Optional):</strong>
              <ul>
                <li>Toggle "Show Steps" to see algorithm execution</li>
                <li>Step through the solution process</li>
                <li>Understand how algorithm builds the tour</li>
              </ul>
            </li>
          </ol>

          <p><strong>Available Algorithms:</strong></p>
          <ul>
            <li><strong>Nearest Neighbor:</strong>
              <ul>
                <li>Simple greedy heuristic</li>
                <li>Starts at depot, always goes to nearest unvisited point</li>
                <li>Fast but may not find optimal solution</li>
              </ul>
            </li>
            <li><strong>2-Opt:</strong>
              <ul>
                <li>Local search improvement method</li>
                <li>Iteratively swaps edges to reduce tour length</li>
                <li>Can improve existing tours significantly</li>
              </ul>
            </li>
            <li><strong>Nearest Neighbor + 2-Opt:</strong>
              <ul>
                <li>Combines both methods</li>
                <li>NN creates initial tour, 2-Opt improves it</li>
                <li>Good balance of speed and quality</li>
              </ul>
            </li>
          </ul>

          <p><strong>Understanding Results:</strong></p>
          <ul>
            <li><strong>Total Distance:</strong> Sum of all segment distances in kilometers</li>
            <li><strong>Tour Sequence:</strong> Order points are visited (Start → P1 → P2 → ... → Start)</li>
            <li><strong>Visual Path:</strong> Lines connecting points in tour order</li>
            <li><strong>Closed Loop:</strong> Path returns to starting point automatically</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Need at least 3 points to solve TSP</li>
            <li>2-Opt usually produces better solutions than Nearest Neighbor alone</li>
            <li>Try different algorithms and compare results</li>
            <li>Use step visualization to learn how algorithms work</li>
            <li>Solution is automatically saved for comparison mode</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 